import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../../pages/client/client_assets/css/Surveys.css';
import '../../../pages/client/client_assets/css/responsive.css';
import enter_Arrow from '../../../pages/client/client_assets/img/presskey.svg';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CommonPopup = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [welcomeData, setWelcomeData] = useState({ q_title: '', q_desc: '' });
    const [endData, setEndData] = useState({ q_title: '', q_desc: '' });
    const [formData, setFormData] = useState({});
    const [questions, setQuestions] = useState([]);
    const [currentStep, setCurrentStep] = useState(0);
    const [showError, setShowError] = useState('');
    const [showStart, setShowStart] = useState(true);
    const [successMsg, setSuccessMsg] = useState(false);
    const [linkType, setLinkType] = useState('');
    const [checkLinkData, setCheckLinkData] = useState(null);


    const fetchQuestions = async () => {
        try {
            const url = 'https://api.skepper.in/check_link_and_get_id.php';
            const requestBody = { link: window.location.pathname.split('/').filter(Boolean).pop() };

            const checkLinkResponse = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody),
            });
            
            const checkLinkData = await checkLinkResponse.json();
            setCheckLinkData(checkLinkData);  // Store it in state
            

            if (!checkLinkData.success) {
                navigate('/404');
                return;
            }

            setLinkType(checkLinkData.link_type); // Store the link_type in state

            let questionsEndpoint;
            switch (checkLinkData.link_type) {
                case 'cform_link':
                    questionsEndpoint = 'get_all_cquestions.php';
                    break;
                case 'eform_link':
                    questionsEndpoint = 'get_all_equestions.php';
                    break;
                case 'pform_link':
                    questionsEndpoint = 'get_all_pquestions.php';
                    break;
                case 'iform_link':
                    questionsEndpoint = 'get_all_iquestions.php';
                    break;
                default:
                    console.error('Invalid link type');
                    return;
            }

            const questionsResponse = await fetch(`https://api.skepper.in/${questionsEndpoint}`);
            const questionsData = await questionsResponse.json();

            const welcomeQuestion = questionsData.questions.find((q) => q.q_type === 'welcome');
            if (welcomeQuestion) {
                setWelcomeData({
                    q_title: welcomeQuestion.q_title,
                    q_desc: welcomeQuestion.q_desc,
                });
            }

            const endQuestion = questionsData.questions.find((q) => q.q_type === 'end');
            if (endQuestion) {
                setEndData({
                    q_title: endQuestion.q_title,
                    q_desc: endQuestion.q_desc,
                });
            }

            const processedQuestions = questionsData.questions.map((question) => {
                const randomAnswerKey = `answerKey_${Math.random().toString(36).substring(7)}`;

                if (question.q_type === 'choice') {
                    return {
                        id: question.id,
                        questionText: question.question,
                        answerKey: randomAnswerKey,
                        options: [
                            question.option1,
                            question.option2,
                            question.option3,
                            question.option4,
                        ],
                        inputType: 'button',
                    };
                } else if (question.q_type === 'key-question') {
                    return {
                        id: question.id,
                        questionText: question.question,
                        answerKey: randomAnswerKey,
                        inputType: 'text',
                    };
                }
                return null;
            }).filter(Boolean);

            setQuestions(processedQuestions);

            const initialFormData = processedQuestions.reduce((acc, question) => {
                acc[question.answerKey] = Array.isArray(question.options) ? [] : '';
                return acc;
            }, {});

            setFormData(initialFormData);
        } catch (error) {
            console.error('Error fetching questions:', error);
            navigate('/404');
        }
    };

    const [logoUrl, setLogoUrl] = useState(null);
    const slug = location.pathname.split('/').pop();
    
    useEffect(() => {
        const slug = location.pathname.split('/').pop();  // Get the slug
        fetch(`https://api.skepper.in/get_logo_user.php?slug=${slug}`, {
            method: 'GET',
            credentials: 'include',  // Make sure to send session cookies
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                setLogoUrl(data.logo_url);  // Set the fetched logo URL
            } else {
                console.error('Error fetching logo:', data.message);
            }
        })
        .catch(error => console.error('Error fetching logo:', error));
    }, [slug]);  // The dependency on `slug` ensures this only runs when the slug changes
    

    useEffect(() => {
        fetchQuestions();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({ ...prevState, [name]: value }));
        if (showError && value.trim() !== '') {
            setShowError('');
        }
    };

    // const handleOptionClick = (answerKey, option) => {
    //     setFormData((prevState) => ({
    //         ...prevState,
    //         [answerKey]: prevState[answerKey]
    //             ? prevState[answerKey].includes(option)
    //                 ? prevState[answerKey].filter((item) => item !== option)
    //                 : [...prevState[answerKey], option]
    //             : [option],
    //     }));
    // };

    const handleOptionClick = (answerKey, option) => {
        setFormData(prevState => ({
            ...prevState,
            [answerKey]: option
        }));
    };
    const nextStep = (currentInputValue) => {
        if (
            (typeof currentInputValue === 'string' && currentInputValue.trim() === '') ||
            (Array.isArray(currentInputValue) && currentInputValue.length === 0)
        ) {
            setShowError('Please fill this in');
        } else {
            setShowError('');
            if (currentStep < questions.length - 1) {
                setCurrentStep(currentStep + 1);
            } else {
                handleSubmit();
            }
        }
    };


    // Enter key press
        useEffect(() => {
            const handleKeyDown = (event) => {
                if (event.key === "Enter") {
                    event.preventDefault();
                    if (showStart) {
                        setShowStart(false);
                    } else {
                        const currentInput = formData[questions[currentStep]?.answerKey];
                        nextStep(currentInput);
                    }
                }
            };
        
            window.addEventListener("keydown", handleKeyDown);
        
            return () => window.removeEventListener("keydown", handleKeyDown);
        }, [showStart, currentStep, formData, questions]); 
        
    
        const alphabetOrder = ["A","B","C","D"]
    const handleSubmit = async (e) => {
        if (e) e.preventDefault(); // Prevent page refresh

        // Construct the submission data
        const submissionData = {
            form_user: checkLinkData.id,
            link_type: linkType,  // Use the link_type from the API response
            questions: Object.keys(formData).map((answerKey) => {
                const question = questions.find(q => q.answerKey === answerKey);
                if (!question) {
                    console.error(`Question for answerKey ${answerKey} not found.`);
                    return null;  // Avoid null if the question is not found
                }

                // Ensure answer is a string, even for multiple-choice questions
                const answer = Array.isArray(formData[answerKey])
                    ? formData[answerKey].join(', ')  // Convert array to a comma-separated string
                    : formData[answerKey] || '';  // Use empty string if no answer

                return { question_id: question.id, answer };
            }).filter(Boolean),  // Filter out any null values
        };

        console.log('Submission Data:', submissionData);  // Log the data to verify

        try {
            const response = await fetch('https://api.skepper.in/insert_submission.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(submissionData),
                credentials: 'include',
            });

            const result = await response.json();
            console.log('Response from server:', result);  // Log the server response

            if (result.success) {
                setSuccessMsg(true); // Set success to true to show the success message
            } else {
                setShowError(`Submission failed: ${result.message}`); // Show the error message from the backend
            }
        } catch (error) {
            console.error('Error during form submission:', error);
            setShowError('Error submitting form. Please try again.');
        }
    };



    return (
        <div id='wrapper' className='mobile_form'>
            <div className="modal show common_popup question_popup">
                            <div className="log_upload">
                                 <img src={logoUrl || 'https://api.skepper.in/uploads/Logo.jpg'} alt="User Logo" className="d_logo" />
                            </div>
                <Modal.Dialog>
                    <Modal.Body>
                        <div className="form_wrapper">
                            <div className='row'>


                                <div className='parent'>
                                    <div className="form_sec">
                                        
                                        {showStart ? (
                                            <div className='start'>
                                                <h3>{welcomeData.q_title}</h3>
                                                <p>{welcomeData.q_desc}</p>
                                                <div className='start_btn'>
                                                    <button onClick={() => setShowStart(false)}>Start</button>
                                                    <p>Press Enter <img src={enter_Arrow} alt="Enter Arrow" /></p>
                                                </div>
                                            </div>
                                        ) : successMsg ? (
                                            <div className='success-message'>
                                                <h4>{endData.q_title}</h4>
                                                <p>{endData.q_desc}</p>
                                            </div>
                                        ) : (
                                            <div className='question_form'>
                                                <form onSubmit={handleSubmit}>
                                                    {questions.map((question, index) => (
                                                        currentStep === index && (
                                                            <div key={question.id}>
                                                                <label>{index+1}. {question.questionText} 
                                                               
                                                                </label>
                                                                {question.inputType === 'button' ? 
                                                                    question.options.map((option,orderIndex) => (
                                                                        <div className='check_form' key={option}>
                                                                            <div 
                                                                                className={`button-option ${formData[question.answerKey]?.includes(option) ? 'active' : ''}`}
                                                                                onClick={() => handleOptionClick(question.answerKey, option)}
                                                                            >
                                                                                {/* <span className="button-label">{option.charAt(0)}</span> */}
                                                                                <span className='alphabet_border'> {alphabetOrder[orderIndex]}</span>
                                                                                {option.slice(0)}
                                                                            </div>
                                                                        </div>
                                                                    )) : (
                                                                    <div className='text_form'>
                                                                        <input
                                                                            type={question.inputType}
                                                                            value={formData[question.answerKey] || ''}
                                                                            onChange={(e) => handleInputChange(e)}
                                                                            name={question.answerKey}
                                                                            required
                                                                        />
                                                                    </div>
                                                                )}
                                                                <div className='next_prev'>
                                                                    {index > 0 && (
                                                                        <button type="button" onClick={() => setCurrentStep(currentStep - 1)}>Previous</button>
                                                                    )}
                                                                    {index < questions.length - 1 ? (
                                                                        <button 
                                                                            type="button" 
                                                                            onClick={() => nextStep(formData[questions[currentStep].answerKey])}
                                                                            disabled={!formData[questions[currentStep].answerKey]} // Disable next if field is empty
                                                                        >
                                                                            Next
                                                                        </button>
                                                                    ) : (
                                                                        <button type="submit">Submit</button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )
                                                    ))}
                                                    {showError && <p className="error-message">{showError}</p>}
                                                </form>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal.Dialog>
            </div>
            <ToastContainer />
        </div>
    );
};

export default CommonPopup;
